import React from 'react'
import { IIconProps } from '~shared/components/icons/types'

const IconDownload: React.FC<IIconProps> = (props) => {
  return (
    <>
      <svg
        xmlns='http://www.w3.org/2000/svg'
        height={props.width ? props.width : '24px'}
        width={props.width ? props.width : '24px'}
        fill={props.color ? props.color : '#000000'}
        viewBox='71 30 170.2 99.2'
      >
        <path
          fill={props.color ? props.color : '#000000'}
          d='M160.6,31.5 185.5,31.6 185.3,96.9 201.4,94.2 172.6,138.2 144,93.7 160.4,96.8Z'
        />
        <path
          fill={props.color ? props.color : '#000000'}
          d='M233.1,151.6H113.8c-1.4,0-2.5-1.1-2.5-2.5v-21c0-1.4,1.1-2.5,2.5-2.5s2.5,1.1,
          2.5,2.5v18.5h114.2v-18.5c0-1.4,1.1-2.5,2.5-2.5s2.5,1.1,2.5,2.5v21C235.6,150.5,234.5,151.6,233.1,151.6z'
        />
      </svg>
    </>
  )
}

export default IconDownload
